/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { Base, markType } from "./type";
/**
 * @hidden
 */
var DataSourceAggregatedResult = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(DataSourceAggregatedResult, _super);
    function DataSourceAggregatedResult() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._item = null;
        _this._transactionType = 0;
        _this._keys = null;
        _this._values = null;
        return _this;
    }
    Object.defineProperty(DataSourceAggregatedResult.prototype, "item", {
        get: function () {
            return this._item;
        },
        set: function (a) {
            this._item = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataSourceAggregatedResult.prototype, "transactionType", {
        get: function () {
            return this._transactionType;
        },
        set: function (a) {
            this._transactionType = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataSourceAggregatedResult.prototype, "keys", {
        get: function () {
            return this._keys;
        },
        set: function (a) {
            this._keys = a;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(DataSourceAggregatedResult.prototype, "values", {
        get: function () {
            return this._values;
        },
        set: function (a) {
            this._values = a;
        },
        enumerable: true,
        configurable: true
    });
    DataSourceAggregatedResult.$t = markType(DataSourceAggregatedResult, 'DataSourceAggregatedResult');
    return DataSourceAggregatedResult;
}(Base));
export { DataSourceAggregatedResult };
//# sourceMappingURL=DataSourceAggregatedResult.js.map
